import React from "react";
import { TabsContainer } from "./tabs-style";
import { TabsProps } from "./tabs-types";

const Tabs = ({ tabs, currentTab, onClickTab, children }: TabsProps) => {
  return (
    <TabsContainer>
      <div className="dashboard-tabs">
        <ul>
          {tabs.map((tab) => (
            <li
              key={tab}
              className={`${currentTab === tab ? `tab-selected` : `tab-not-selected`}`}
              data-id={tab}
              onClick={() => onClickTab(tab)}
            >
              {tab.toLocaleUpperCase()}
            </li>
          ))}
        </ul>
      </div>

      <div className="selected-tab-content">{children}</div>
    </TabsContainer>
  );
};

export default Tabs;
